import type { ProfileStore } from '../sim/meta/ProfileStore';

const KEY = 'descent.profile';

/**
 * App-boundary profile persistence. try/catch both ways: private-mode Safari
 * throws on write, and a broken payload must never block boot (Profile falls
 * back to defaults on bad raw data anyway).
 */
export class LocalStorageProfileStore implements ProfileStore {
  load(): string | null {
    try {
      return localStorage.getItem(KEY);
    } catch {
      return null;
    }
  }

  save(raw: string): void {
    try {
      localStorage.setItem(KEY, raw);
    } catch {
      // Storage unavailable — play on with an ephemeral profile.
    }
  }
}
